module.exports = __webpack_public_path__ + "static/media/manfredWeiss.34a2c2a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/manfredWeiss.jpg
// module id = 1578
// module chunks = 1